/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_Leveling_ImagesInputs */



/**
* | output |
* | --- |
* | "An image library for your cards and level-up messages" |
*
* @param {Pricing_Compare_Leveling_ImagesInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_leveling_images = /** @type {((inputs?: Pricing_Compare_Leveling_ImagesInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_Leveling_ImagesInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Библиотека изображений для карточек и сообщений о повышении уровня")
	return /** @type {LocalizedString} */ ("An image library for your cards and level-up messages")
});